export class NomiDescrittoriSezione {
  //  public static readonly SEZIONE_DATI_GENERALI_PRATICA = 'SezioneDatiGenerali';
  //  public static readonly SEZIONE_CLASSIFICAZIONE_PRATICA = 'SezioneClassificazione';
  public static readonly SEZIONE_DATI_GENERALI_FASCICOLO = 'SezioneDatiGenerali';
  public static readonly DESCRITTORE_PRATICA = 'Pratica';
  public static readonly DESCRITTORE_FASCICOLO = 'Fascicolo';
  public static readonly SEZIONE_TITOLI_ESECUTIVI = 'SezioneTitoliEsecutivi';
  public static readonly SEZIONE_CONTROPARTI_FASCICOLO = 'SezioneControparti';
  public static readonly SEZIONE_PATOLOGIE = 'SezionePatologie';
  public static readonly SEZIONE_SCHEDE_RECUPERO_FASCICOLO =
    'SezioneSchedeRecupero';
  public static readonly SEZIONE_SCHEDE_ESECUZIONE_FASCICOLO =
    'SezioneSchedeEsecuzione';
  public static readonly SEZIONE_LEGALI_FASCICOLO = 'SezioneLegali';
  public static readonly SEZIONE_ALTRE_PARTI_FASCICOLO = 'SezioneAltreParti';
  public static readonly SEZIONE_ECONOMICA_FASCICOLO = 'SezioneDatiEconomici';
  public static readonly SEZIONE_SCADENZARIO_FASCICOLO = 'SezioneScadenze';
  public static readonly SEZIONE_ATTI_FASCICOLO = 'SezioneAtti';
  public static readonly SEZIONE_ESITI_FASCICOLO = 'SezioneEsiti';
  public static readonly SEZIONE_CENSIMENTO_DOCUMENTI_FASCICOLO = 'SezioneCensimentoDocumenti';
  public static readonly SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO =
    'SezioneDocumentazioneAllegata';
  public static readonly SEZIONE_PAGAMENTI_FASCICOLO = 'SezionePagamenti';
  public static readonly SEZIONE_INCASSI_FASCICOLO = 'SezioneIncassi';
  public static readonly SEZIONE_PARCELLE_GIUDIZIALI_FASCICOLO =
    'SezioneParcelle';
  public static readonly SEZIONE_PARCELLE_STRAGIUDIZIALI_FASCICOLO =
    'SezioneParcelle';
  public static readonly SEZIONE_PARCELLE = 'SezioneParcelle';
  public static readonly SEZIONE_FATTURE_FASCICOLO = 'SezioneFatture';
  public static readonly ASSEGNAZIONE_PER_SMISTAMENTO =
    'AssegnazioneSmistamento';
  public static readonly ASSEGNAZIONE_PER_COMPETENZA = 'AssegnazioneCompetenza';
  public static readonly ASSEGNATARI_VISUALIZZAZIONE = 'Assegnatari';
  public static readonly SEZIONE_BENI_MOBILI_FASCICOLO = 'SezioneBeniMobili';
  public static readonly SEZIONE_BENI_IMMOBILI_FASCICOLO = 'SezioneBeniImmobili';
  public static readonly SEZIONE_DATI_PIGNORAMENTO_FASCICOLO = 'SezioneDatiPignoramento';
  public static readonly SEZIONE_LETTERE_DIFFIDA_FASCICOLO =
    'SezioneLettereDiffida';

  public static readonly SEZIONE_PROVE_SCRITTE = 'SezioneProveScritte';
  public static readonly SEZIONE_BANCHE_DATI_FASCICOLO = 'SezioneBancheDati';
  public static readonly SEZIONE_REATI_FASCICOLO = 'SezioneReati';

  // DESCRITTORI GENERICI
  public static readonly DESCRITTORE_RIUNIONE_GIUDIZI = 'RiunioneGiudizi';
  public static readonly DESCRITTORE_RIMOZIONE_RIUNIONE_GIUDIZI =
    'RimozioneDefinizione';
  public static readonly DESCRITTORE_RIMOZIONE_DEFINIZIONE =
    'RimozioneDefinizione';
  public static readonly DESCRITTORE_DEFINIZIONE = 'Definizione';
  public static readonly DESCRITTORE_CANCELLAZIONE = 'Cancellazione';
  public static readonly DESCRITTORE_CREAZIONE_PRATICA = 'CreazionePratica';
  public static readonly DESCRITTORE_GESTIONE_TIPOLOGICHE =
    'GestioneTipologiche';
  public static readonly DESCRITTORE_GESTIONE_ANAGRAFICHE =
    'GestioneAnagrafiche';
  public static readonly DESCRITTORE_GESTIONE_TABELLE = 'GestioneTabelle';
  public static readonly DESCRITTORE_GESTIONE_UTENTI = 'GestioneUtenti';
  public static readonly DESCRITTORE_GESTIONE_PROFILI = 'GestioneProfili';
  public static readonly DESCRITTORE_GESTIONE_FORMULARIO = 'GestioneFormulario';
  public static readonly DESCRITTORE_GESTIONE_METADATI = 'GestioneMetadati';
  public static readonly DESCRITTORE_CRUSCOTTO_NOTIFICHE = 'CruscottoNotifiche';
  public static readonly DESCRITTORE_CRUSCOTTO_CONSERVAZIONE = 'CruscottoConservazione'
  public static readonly DESCRITTORE_ESTRAZIONE = 'Estrazione';
  public static readonly DESCRITTORE_PCT_DEPOSITO =
    'ProcessoTelematicoDeposito';
  public static readonly DESCRITTORE_PCT_CONSULTAZIONE =
    'ProcessoTelematicoConsultazione';
  public static readonly DESCRITTORE_REPORTISTICA = 'Reportistica';
  public static readonly DESCRITTORE_REPORT_STATO_PRATICA =
    'ReportStatoPratica';
  public static readonly DESCRITTORE_REPORT_STATO_FASCICOLO =
    'ReportStatoFascicolo';
  public static readonly DESCRITTORE_REPORT_ESITI = 'ReportEsiti';
  public static readonly DESCRITTORE_REPORT_CLASSIFICAZIONI =
    'ReportClassificazioni';
  public static readonly DESCRITTORE_REPORT_DATI_ECONOMICI = 'ReportEconomici';
  public static readonly DESCRITTORE_REPORT_BILANCIO = 'ReportBilancio';
  public static readonly DESCRITTORE_REPORT_MENSILIZZAZIONI =
    'ReportMensilizzazioni';
  public static readonly DESCRITTORE_REPORT_LEGALI = 'ReportLegali';
  public static readonly DESCRITTORE_REPORT_ADEMPIMENTI = 'ReportAdempimenti';
  public static readonly DESCRITTORE_REPORT_SINISTRO_SANITARIO = 'ReportSinistroSanitario';
  public static readonly DESCRITTORE_REPORT_770 = 'Report770';
  public static readonly DESCRITTORE_AGGIORNAMENTO_MULTI_CLASSIFICAZIONE =
    'AggiornamentoMultiClassificazione';
  public static readonly DESCRITTORE_COPIA_PRATICA = 'CopiaPratica';
  public static readonly DESCRITTORE_ARCHIVIAZIONE = 'Archiviazione';
  public static readonly DESCRITTORE_CORRELA_PRATICA = 'CorrelaPratica';
  public static readonly DESCRITTORE_COPIA_FASCICOLO = 'CopiaFascicolo';

  //public static readonly DESCRITTORE_GESTIONE_CDA = 'GestioneCdA';

  public static readonly DESCRITTORE_GESTIONE_SOCIETA = 'GestioneSocieta';
  public static readonly DESCRITTORE_RUBRICA = 'Rubrica';
  public static readonly DESCRITTORE_DASHBOARD = 'Dashboard';
  public static readonly DESCRITTORE_ORGANI = 'Organi';
  public static readonly DESCRITTORE_DIPARTIMENTI = 'Dipartimenti';
  public static readonly DESCRITTORE_CANCELLERIA_TELEMATICA = 'CancelleriaTelematica';
  public static readonly DESCRITTORE_CANCELLERIA_EVENTI = 'EventiCancelleria';
  public static readonly DESCRITTORE_GESTIONE_DOCUMENTI = 'GestioneDocumenti';
  public static readonly DESCRITTORE_GENERAZIONE_DOCUMENTO = 'GeneraDocumento';
}

export class NomiRuoliUtente {
  public static readonly VISUALIZZATORE_AMIANTO = 'ROL_VISUALIZZATORE_AMIANTO';
}
// TODO

export class IdDescrittoriDiSezione {
  public static readonly TutteLeSezioni = [
    {
      nomeSezione: 'controparti',
      esn: NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO,
      nomeCampoId: 'idSezioneControparti',
      nomeCampoEntityList: 'controparti',
    },
    {
      nomeSezione: 'patologie',
      esn: NomiDescrittoriSezione.SEZIONE_PATOLOGIE,
      nomeCampoId: 'idSezionePatologie',
      nomeCampoEntityList: 'patologie',
    },
    {
      nomeSezione: 'schede recupero',
      esn: NomiDescrittoriSezione.SEZIONE_SCHEDE_RECUPERO_FASCICOLO,
      nomeCampoId: 'idSezioneSchedeRecupero',
      nomeCampoEntityList: 'schede',
    },
    {
      nomeSezione: 'schede esecuzione',
      esn: NomiDescrittoriSezione.SEZIONE_SCHEDE_ESECUZIONE_FASCICOLO,
      nomeCampoId: 'idSezioneSchedeEsecuzione',
      nomeCampoEntityList: 'schede',
    },
    {
      nomeSezione: 'legali',
      esn: NomiDescrittoriSezione.SEZIONE_LEGALI_FASCICOLO,
      nomeCampoId: 'idSezioneLegali',
      nomeCampoEntityList: 'legaliIncaricati',
    },
    {
      nomeSezione: 'altre parti', // localStorage.getItem('TLF_TENANT') === 'TNT_FERROVIE' ? 'altri soggetti' : 'altre parti',
      esn: NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO,
      nomeCampoId: 'idSezioneAltreParti',
      nomeCampoEntityList: 'altreParti',
    },
    {
      nomeSezione:
        localStorage.getItem('TLF_TENANT') === 'TNT_FERROVIE'
          ? 'scadenze'
          : 'scadenzario',
      esn: NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO,
      nomeCampoId: 'idSezioneScadenze',
      nomeCampoEntityList: 'scadenze',
    },
    {
      nomeSezione: 'dati economici',
      esn: NomiDescrittoriSezione.SEZIONE_ECONOMICA_FASCICOLO,
      nomeCampoId: 'idSezioneDatiEconomici',
      nomeCampoEntityList: '',
    },
    {
      nomeSezione: 'atti',
      esn: NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO,
      nomeCampoId: 'idSezioneAtti',
      nomeCampoEntityList: 'atti',
    },
    {
      nomeSezione: 'esiti',
      esn: NomiDescrittoriSezione.SEZIONE_ESITI_FASCICOLO,
      nomeCampoId: 'idSezioneEsiti',
      nomeCampoEntityList: 'esiti',
    },
    {
      nomeSezione: 'documentazione allegata',
      esn: NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO,
      nomeCampoId: 'idSezioneDocumentazioneAllegata',
      nomeCampoEntityList: 'documentiAggregati',
    },
    {
      nomeSezione: 'pagamenti',
      esn: NomiDescrittoriSezione.SEZIONE_PAGAMENTI_FASCICOLO,
      nomeCampoId: 'idSezionePagamenti',
      nomeCampoEntityList: 'pagamenti',
    },
    {
      nomeSezione: 'incassi',
      esn: NomiDescrittoriSezione.SEZIONE_INCASSI_FASCICOLO,
      nomeCampoId: 'idSezioneIncassi',
      nomeCampoEntityList: 'incassi',
    },
    {
      nomeSezione:
        localStorage.getItem('TLF_TENANT') === 'TNT_FERROVIE'
          ? 'notule'
          : 'parcelle',
      esn: NomiDescrittoriSezione.SEZIONE_PARCELLE_GIUDIZIALI_FASCICOLO,
      nomeCampoId: 'idSezioneParcelle',
      nomeCampoEntityList: 'parcelle',
    },
    {
      nomeSezione: 'fatture',
      esn: NomiDescrittoriSezione.SEZIONE_FATTURE_FASCICOLO,
      nomeCampoId: 'idSezioneFatture',
      nomeCampoEntityList: 'fatture',
    },
    {
      nomeSezione: 'assegnatari',
      esn: NomiDescrittoriSezione.ASSEGNAZIONE_PER_SMISTAMENTO,
      nomeCampoId: 'idSezioneAssegnazionePerSmistamento',
      nomeCampoEntityList: '',
    },
    {
      nomeSezione: 'assegnatari',
      esn: NomiDescrittoriSezione.ASSEGNAZIONE_PER_COMPETENZA,
      nomeCampoId: 'idSezioneAssegnazionePerCompetenza',
      nomeCampoEntityList: '',
    },
    {
      nomeSezione: 'beni mobili',
      esn: NomiDescrittoriSezione.SEZIONE_BENI_MOBILI_FASCICOLO,
      nomeCampoId: 'idSezioneBeniPignoratiMobili',
      nomeCampoEntityList: 'beniPignoratiMobili',
    },
    {
      nomeSezione: 'lettere diffida',
      esn: NomiDescrittoriSezione.SEZIONE_LETTERE_DIFFIDA_FASCICOLO,
      nomeCampoId: 'idSezioneLettereDiffida',
      nomeCampoEntityList: 'lettereDiffida',
    },
    {
      nomeSezione: 'prove scritte',
      esn: NomiDescrittoriSezione.SEZIONE_PROVE_SCRITTE,
      nomeCampoId: 'idSezioneProveScritte',
      nomeCampoEntityList: 'proveScritte',
    },
    {
      nomeSezione: 'titoli esecutivi',
      esn: NomiDescrittoriSezione.SEZIONE_TITOLI_ESECUTIVI,
      nomeCampoId: 'idSezioneTitoliEsecutivi',
      nomeCampoEntityList: 'titoliEsecutivi',
    },
    {
      nomeSezione: 'beni immobili',
      esn: NomiDescrittoriSezione.SEZIONE_BENI_IMMOBILI_FASCICOLO,
      nomeCampoId: 'idSezioneBeniPignoratiImmobili',
      nomeCampoEntityList: 'beniPignoratiImmobili',
    },
    {
      nomeSezione: 'dati pignoramento',
      esn: NomiDescrittoriSezione.SEZIONE_DATI_PIGNORAMENTO_FASCICOLO,
      nomeCampoId: 'idSezioneDatiPignoramento',
      nomeCampoEntityList: 'datiPignoramento',
    },
    {
      nomeSezione: 'reati',
      esn: NomiDescrittoriSezione.SEZIONE_REATI_FASCICOLO,
      nomeCampoId: 'idSezioneReati',
      nomeCampoEntityList: 'reati',
    },
  ];
}
